import {loadYoutubeAPI} from "../Utils/Utils.js";

const VideoOverlay = () => {

	const videoOverlay = document.querySelector('#video-overlay');
	if(!videoOverlay) {
		return;
	}

	let player = null;
	const videoContainer = videoOverlay.querySelector('.video-container');


	videoOverlay.querySelector('.close-btn').addEventListener('click', e => {
		e.preventDefault();
		hideVideo();
	});


	const handlePlayBtnClick = (e) => {
		e.preventDefault();
		loadVideo(e.currentTarget.dataset.src)
	};


	const loadVideo = (youtubeId) => {

		if(player) {
			player.playVideo();
		}
		else {

			videoOverlay.classList.add('js-active');

			loadYoutubeAPI(() => {

				const placeholder = document.createElement('div');
				videoContainer.appendChild(placeholder);

				const options = {
					videoId: youtubeId,
					//host: 'https://www.youtube-nocookie.com',
					width: '1600',
					height: '900',
					playerVars: {
						modestbranding: 1,
						playsinline: 1,
						rel: 0,
						autoplay: 1,
					},
					events: {
						//'onReady': onPlayerReady,
						'onStateChange': (e) => {
							if(e.data === YT.PlayerState.ENDED) {
								//hideVideo();
							}
						}
					}
				};
				player = new YT.Player(placeholder, options);
			});
		}
	};

	const hideVideo = () => {

		videoOverlay.classList.remove('js-active');
		if(player)
		{
			player.pauseVideo();
			videoContainer.textContent = '';
			player = null;
		}
	};


	document.querySelectorAll('.play-btn[data-target="video-overlay"]').forEach(btn => {
		btn.addEventListener('click', handlePlayBtnClick);
	});

};

export default VideoOverlay;